
import { defineComponent, ref, computed } from 'vue'
import { notification } from 'ant-design-vue';
import { apiDownloadQuizAttachment } from '@/api/quizFileApi';
export default defineComponent({
  name: 'FileUpload',
  props: {
    name: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: '*/*',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    upload: (
      files: File[],
      resolve: (value?: unknown) => void,
      reject: (reason?: any) => void
    ) => true,
    handleFileDownload: () => true,
    handleFileRemove: () => true,
  },

  setup(props, { emit }) {
    const dragOver = ref(false)
    const files = ref<File[]>([])
    const fileInput = ref<HTMLInputElement | null>(null)

    const fileNames = computed(() => files.value.map(f => f.name).join(', '))

    const containerStyle = computed(() => ({
      border: '2px dashed',
      borderColor: dragOver.value ? '#3b82f6' : '#d1d5db',
      borderRadius: '16px',
      padding: '24px',
      textAlign: 'center',
      cursor: 'pointer',
      backgroundColor: dragOver.value ? '#eff6ff' : '#fff',
      transition: 'all 0.3s ease',
    }))

    const textStyle = {
      color: '#6b7280',
      fontSize: '16px',
    }

    const browseStyle = {
      color: '#3b82f6',
      fontWeight: '600',
      cursor: 'pointer',
    }

    const uploadedRowStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      flexWrap: 'wrap' as const,
      marginBottom: '8px',
      padding: '10px 14px',
      backgroundColor: '#f8fafc',
      borderRadius: '10px',
      border: '1px solid #e2e8f0',
    }

    const fileNameStyle = {
      color: '#374151',
      fontSize: '14px',
      fontWeight: '500',
      maxWidth: '180px',
      overflow: 'hidden',
      textOverflow: 'ellipsis' as const,
      whiteSpace: 'nowrap' as const,
    }

    const removeButtonStyle = {
      marginLeft: '4px',
      padding: '4px 12px',
      fontSize: '13px',
      fontWeight: '500',
      color: '#dc2626',
      backgroundColor: 'transparent',
      border: '1px solid #fca5a5',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    }

    const fileListStyle = {
      marginTop: '16px',
      fontSize: '14px',
      color: '#374151',
    }

    const buttonStyle = {
      marginTop: '16px',
      backgroundColor: '#3b82f6',
      color: 'white',
      padding: '8px 16px',
      borderRadius: '12px',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
    }

    // --- Methods ---
    const triggerFileInput = () => fileInput.value?.click()

    const handleFileSelect = (e: Event) => {
      const target = e.target as HTMLInputElement
      if (target.files) {
        files.value = Array.from(target.files)
      }
    }

    const handleDrop = (e: DragEvent) => {
      dragOver.value = false
      if (e.dataTransfer?.files) {
        files.value = Array.from(e.dataTransfer.files)
      }
    }

    const uploadFiles = () => {

      emit('upload', files.value, () => {
        reset();
        notification.success({
          message: 'Success!',
          description: 'File uploaded successfully',
          duration: 4
        });
      }, () => {
        console.log('catch')
      })
    }


    const reset = () => {
      files.value = []
      if (fileInput.value) fileInput.value.value = ''
    }


    return {
      props,
      dragOver,
      files,
      fileInput,
      fileNames,
      containerStyle,
      textStyle,
      browseStyle,
      uploadedRowStyle,
      fileNameStyle,
      removeButtonStyle,
      fileListStyle,
      buttonStyle,
      triggerFileInput,
      handleFileSelect,
      handleDrop,
      uploadFiles,
    }
  },
})
